import { createSlice } from "@reduxjs/toolkit";
import {  LeadProps } from "types/lead";
import axios from 'utils/axios';
import { dispatch } from '../index';

const initialState: LeadProps = {
    isOpen: false,
    open: false,
    isCustomerOpen:false,
    lists: [],
    last_page:1,
    current_page:1,
    pageNumber:1,
    pageLimit:5,
    list: null,
    error: null,
    alertPopup: false
  };
const lead = createSlice({
    name: 'lead',
    initialState,
    reducers: {
     
  
      hasError(state, action) {
        state.error = action.payload.error;
      },
  
      // get all project list
      getLists(state, action) {
        state.lists = action.payload;
      },
      setPageNumber(state, action) {
        state.pageNumber = action.payload;
      },
      setPageLimit(state, action) {
        state.pageLimit = action.payload;
      },
      // get project details
      
      setSingleList(state, action) {
        state.list = action.payload;       
      },
  
      // GET Leads
    getLeadsSuccess(state, action) {
        state.lists = action.payload.data;
        state.current_page=action.payload.current_page;
        state.last_page=action.payload.last_page;
        state.total=action.payload.total;
    },

    // ADD Lead
    addLeadSuccess(state, action) {
        state.lists = [...state.lists,action.payload];
    },

    // EDIT Lead
    editLeadSuccess(state, action) {
        var foundIndex = state.lists.findIndex(x => x.id === action.payload.id);
        state.lists[foundIndex] = action.payload;
    },
    //DELETE Lead
    deleteLeadSuccess(state, action) {
      const deleteData = state.lists.filter((list) => list.id !== action.payload);
      state.lists = deleteData;
  },
    alertPopupToggle(state, action) {
      state.alertPopup = action.payload.alertToggle;
    }

    }
  });

  export default lead.reducer;
  export const {  getLists,setPageNumber,setPageLimit,setSingleList,alertPopupToggle} = lead.actions;
  
  export function getLeads(params:any={}) {
    return async () => {
      try {
        const response = await axios.get('lead',{params:params});
        dispatch(lead.actions.getLeadsSuccess(response.data));
      } catch (error) {
        dispatch(lead.actions.hasError(error));
      }
    };
  }

  export function getLead(id: number | undefined) {
    return async () => {
      try {
        const response = await axios.get('lead/'+id);
        dispatch(lead.actions.setSingleList(response.data));
        // console.log(response.data);
        
      } catch (error) {
        dispatch(lead.actions.hasError(error));
      }
    };
   
  }

  export function addLead(leadElement:any) {
    return async () => {
      try {
        console.log(axios.defaults.baseURL);
      
        const response = await axios.post('lead', leadElement);
        dispatch(lead.actions.addLeadSuccess(response.data));
      } catch (error) {
        dispatch(lead.actions.hasError(error));
      }
    };
  }
  
  export function editLead(id: number | undefined,leadElement: any) {
    return async () => {
      try {
        const response = await axios.put('/lead/'+id, leadElement);
        dispatch(lead.actions.editLeadSuccess(response.data));
      } catch (error) {
        dispatch(lead.actions.hasError(error));
      }
    };
  }
  export function deleteLead(id: number | undefined) {
    return async () => {
      try {
        await axios.delete('/lead/'+id);
        dispatch(lead.actions.deleteLeadSuccess(id));
      } catch (error) {
        dispatch(lead.actions.hasError(error));
      }
    };
  }